/**
 * Utilitaires pour la gestion des dates partagés entre composants
 */

/**
 * Parse une date selon le format spécifié
 * Supporte: yyyy-MM-dd, yyyy/MM/dd, dd-MM-yyyy, dd/MM/yyyy, MM-dd-yyyy, MM/dd/yyyy
 */
export function parseDateWithFormat(str: string, formatStr: string): Date | null {
  const sep = formatStr.includes("/") ? "/" : "-";
  const parts = str.split(sep);
  if (parts.length !== 3) return null;

  let year: string | undefined, month: string | undefined, day: string | undefined;
  if (formatStr.startsWith("yyyy")) {
    [year, month, day] = parts;
  } else if (formatStr.startsWith("dd")) {
    [day, month, year] = parts;
  } else if (formatStr.startsWith("MM")) {
    [month, day, year] = parts;
  }

  if (!year || !month || !day) return null;

  const date = new Date(`${year}-${month}-${day}T00:00:00`);
  if (date.getFullYear() === Number(year) && date.getMonth() + 1 === Number(month) && date.getDate() === Number(day)) {
    return date;
  }
  return null;
}

/**
 * Valide si une chaîne correspond à une date valide selon le format
 */
export function validateDate(dateStr: string, dateFormat: string): boolean {
  const date = parseDateWithFormat(dateStr, dateFormat);
  return !!date;
}

/**
 * Formate une date pour l'affichage selon le format spécifié
 */
export function formatDateForDisplay(date: Date, format: string): string {
  const year = date.getFullYear().toString();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");

  if (format.startsWith("yyyy")) {
    return format.replace("yyyy", year).replace("MM", month).replace("dd", day);
  } else if (format.startsWith("dd")) {
    return format.replace("dd", day).replace("MM", month).replace("yyyy", year);
  } else if (format.startsWith("MM")) {
    return format.replace("MM", month).replace("dd", day).replace("yyyy", year);
  }

  return `${year}-${month}-${day}`;
}
